import "./NotFound.css";

export default function NotFound() {
    return (
        <div className="nf-container">
            <h1 className="nf-title">404</h1>
            <p className="nf-text">Page not found</p>
            {/* <a href="/" className="nf-btn">Go Home</a> */}

            <div className="nf-blob"></div>
        </div>
    );
}
